import { render, staticRenderFns } from "./image-link.vue?vue&type=template&id=41823cdf&scoped=true&lang=pug&"
import script from "./image-link.ts?vue&type=script&lang=ts&"
export * from "./image-link.ts?vue&type=script&lang=ts&"
import style0 from "./image-link.vue?vue&type=style&index=0&id=41823cdf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41823cdf",
  null
  
)

export default component.exports